import * as React from 'react'
function SvgOffice(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22 4v4h6c1.2 0 2 .8 2 2v12h4c1.2 0 2 .8 2 2v10c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V24c0-1.2.8-2 2-2h4V10c0-1.2.8-2 2-2h6V4h4zm4 8H14v20h4v-6h4v6h4V12zm-4 4v4h-4v-4h4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOffice
